/* eslint-disable max-classes-per-file */
import Rules from "./Rules";

class ApplicationRules extends Rules {
  static register: $TSFixMe;

  static delegate: $TSFixMe;

  nodesIncludes() {
    return "type,type.parent";
  }

  minDecimalDigits() {
    return 0;
  }

  hasEditValueSettingsButton() {
    return false;
  }

  hasEditValueUnitsButton() {
    return false;
  }

  maxDecimalDigits() {
    return 3;
  }

  searchScope() {
    return ["assets", "nodes", "instrumentations"];
  }

  userSpecifications() {
    return ["eh.pcps.user.newsletter_recipient"];
  }

  allowedTrialApp() {
    return false;
  }

  showDeleteMeasurementValuesButton() {
    return false;
  }

  hasConnectedAssetAddon() {
    return false;
  }

  showHealthNotifications() {
    return false;
  }

  withOneSubscription() {
    return false;
  }

  showFilesInNodeDetails() {
    return false;
  }

  showFilesExportInContextMenu() {
    return false;
  }

  usePreferredValueSettings() {
    return false;
  }

  shouldShowCustomDisplayLabelForValues() {
    return false;
  }

  hiddenHeartbeatMonitoringValueKeys(): string[] {
    return [];
  }

  hasMonitoringValueKeyTranslation() {
    return false;
  }

  showHBMValues() {
    return false;
  }

  showThresholdButton() {
    return false;
  }

  showMonitoringHistoryHeading() {
    return false;
  }
}

export class ApplicationRulesFactory {
  get(rule: $TSFixMe, a: $TSFixMe, b: $TSFixMe, c: $TSFixMe) {
    return ApplicationRules.delegate.get(rule, a, b, c);
  }
}

ApplicationRules.delegate = new ApplicationRules();

ApplicationRules.register = (Clazz: $TSFixMe) => {
  if (Clazz) {
    ApplicationRules.delegate = new Clazz();
  } else {
    ApplicationRules.delegate = new ApplicationRules();
  }
};

export default ApplicationRules;
